import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (param) {
  const { isRequestSuccessed, data, isLoading, exec } = useRequest({
    url: '',
    name: 'GET_PRODUCTION_ORDER',
    method: 'GET',
  });

  useEffect(() => {
    if (param) {
      let url = '/api/work-orders?has_ipqcs=2';
      Object.keys(param).forEach((key) => {
        url += '&' + key + '=' + param[key];
      });
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [data || [], isRequestSuccessed, isLoading];
});
